import Dodoable from 'models/dodoable'
import getModelMember from 'braindamage/api/getModelMember'
import { useQuery } from '@tanstack/react-query'

export default ({ dodoableId }) => {
  return useQuery({
    queryKey: ['dodoable', dodoableId],
    queryFn: async () => {
      const data = await getModelMember(`/api/dodoables/${dodoableId}`, Dodoable)
      return data
    }
  })
}
